export function initialSlotData() {
  return {
    
    isSelected: false,
    isCanceling: false,
    isAvailableForBooking: true,

    // If there is an active or current session, to make sure
    // ongoing sessions are being shown and to optimize
    // showing the 'Join' button for next and ongoing sessions
    hasCurrentOrNextSession: false,
  };
}

